<template>
    <div>
      <h1>About Page</h1>
      <p>Learn more about us on this page.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutPage', // Change the name to be multi-word
  };
  </script>